/* KB Endlos-Pfeile für Produktreihen (2026-08-16)

   Dawns SliderComponent deaktiviert die Pfeile an den Enden der Reihe. Julien:
   „bei Ende, dass man wieder am Anfang ist — flüssiges Durchlaufen."

   Zwei Eingriffe, beide ohne Dawn-Dateien anzufassen:
   1. `enableSliderLooping = true` — Dawn prüft dieses Flag selbst (global.js)
      und überspringt dann das Deaktivieren der Buttons.
   2. Ein Click-Listener in der Capture-Phase: steht die Reihe am Ende, wird
      Dawns eigener Handler gestoppt und stattdessen an den Anfang gescrollt
      (und umgekehrt). Das Scrollen selbst bleibt Dawns `scroll-behavior:
      smooth` überlassen, damit es sich wie normales Weiterblättern anfühlt.

   Betrifft nur <slider-component>. <slideshow-component> ist ein eigenes
   Element mit eigener Loop-Logik und wird davon nicht erfasst.
*/
(function () {
  'use strict';

  var RAND = 2; // px Toleranz gegen Sub-Pixel-Rundung beim Scrollen

  function amAnfang(slider) {
    return slider.scrollLeft <= RAND;
  }

  function amEnde(slider) {
    return slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - RAND;
  }

  /* Beschriftung, die beim Hover aufklappt. Der Text kommt aus
     locales/de.json über window.kbSliderStrings (in theme.liquid gesetzt) —
     nicht als String hier im Skript, damit er übersetzbar bleibt.
     aria-hidden, weil der Button über sein eigenes aria-label bereits
     benannt ist; sonst läse der Screenreader beides. */
  function labelEinsetzen(button, text) {
    if (!text || button.querySelector('.kb-slider-btn__label')) return;
    var span = document.createElement('span');
    span.className = 'kb-slider-btn__label';
    span.setAttribute('aria-hidden', 'true');
    span.textContent = text;
    button.appendChild(span);
  }

  function init(component) {
    if (component.dataset.kbLoop === 'on') return;

    var slider = component.querySelector('.slider');
    var prev = component.querySelector('button[name="previous"]');
    var next = component.querySelector('button[name="next"]');
    if (!slider || !prev || !next) return;

    // Nur sinnvoll, wenn überhaupt etwas zu scrollen ist
    if (slider.scrollWidth <= slider.clientWidth + RAND) return;

    component.dataset.kbLoop = 'on';
    component.enableSliderLooping = true;
    prev.removeAttribute('disabled');
    next.removeAttribute('disabled');

    var strings = window.kbSliderStrings || {};
    labelEinsetzen(next, strings.next);
    labelEinsetzen(prev, strings.previous);

    function beiKlick(event) {
      var istWeiter = event.currentTarget.name === 'next';
      if (istWeiter && !amEnde(slider)) return;
      if (!istWeiter && !amAnfang(slider)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      slider.scrollTo({ left: istWeiter ? 0 : slider.scrollWidth });
    }

    prev.addEventListener('click', beiKlick, true);
    next.addEventListener('click', beiKlick, true);

    // Dawn schreibt `disabled` bei jedem Scroll neu; falls das Flag einmal
    // nicht greift, hier zurücknehmen.
    slider.addEventListener('scroll', function () {
      prev.removeAttribute('disabled');
      next.removeAttribute('disabled');
    });
  }

  function boot() {
    document.querySelectorAll('slider-component').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Sektionen, die der Theme-Editor neu lädt, ebenfalls verkabeln
  document.addEventListener('shopify:section:load', boot);
})();
